<template>
  <SelectCustom
    class="select"
    :label="locale"
    :options="options"
    v-model="locale"
  />
</template>

<script>
export default {
  name: 'LangSwitcher',

  data () {
    return {
      locale: this.$i18n.locale
    }
  },

  computed: {
    options () {
      return Object.entries(this.$i18n.messages).map(item => {
        return {
          value: item[0],
          label: item[1].langLabel
        }
      })
    }
  },

  watch: {
    locale (val) {
      const route = {
        ...this.$router.currentRoute,

        params: {
          lang: val
        }
      }

      this.$router.push(route)
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 90px;
  padding: 0 !important;
  background: {
    image:
      url('data:image/svg+xml;base64,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'),
      url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlNvbGlkIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtvcGFjaXR5OjAuNDtmaWxsOiNGRkZGRkY7ZW5hYmxlLWJhY2tncm91bmQ6bmV3ICAgIDt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjE2Yy02LjQsMC0xMi41LTIuNS0xNy03TDI1Niw4MkwxMjksMjA5Yy05LjQsOS40LTI0LjYsOS40LTMzLjksMHMtOS40LTI0LjYsMC0zMy45TDIzOSwzMQoJYzkuNC05LjQsMjQuNi05LjQsMzMuOSwwbDAsMGwxNDQsMTQ0YzkuNCw5LjQsOS40LDI0LjYsMCwzMy45QzQxMi41LDIxMy41LDQwNi40LDIxNiw0MDAsMjE2eiBNMjczLDQ4MWwxNDQtMTQ0CgljOS40LTkuNCw5LjQtMjQuNiwwLTMzLjlzLTI0LjYtOS40LTMzLjksMGwtMTI3LDEyN0wxMjksMzAzYy05LjQtOS40LTI0LjYtOS40LTMzLjksMHMtOS40LDI0LjYsMCwzMy45bDE0NCwxNDQKCUMyNDguNCw0OTAuMywyNjMuNiw0OTAuMywyNzMsNDgxTDI3Myw0ODF6Ii8+Cjwvc3ZnPgo=')
      !important;
    position:
      10px 50%,
      calc(100% - 10px) 50%
      !important;
  }
}
</style>
